<template>
<form>
	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Category:</label>
		<div class="col-sm-10">
			<input type="text" class="form-control form-control-sm"
					v-model="form.revisaoManual"
					@input="formm.revisaoManual = $event.target.value.toUpperCase()"
					disabled="disabled">
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">*Chapter:</label>
		<div class="col-sm-10">
			<select class="form-control form-control-sm"
					v-model="form.idCapitulo"
					@input="form.idCapitulo = $event.target.value"
					:disabled="visualizar">
				<option :value="null">ESCOLHA</option>
				<option v-for="(item, index) in categoria.capitulos" :key="index" :value="item.id">{{item.descricao}}</option>
			</select>
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Ata Title:</label>
		<div class="col-sm-10">
			<input  type="text" class="form-control form-control-sm"
					v-model="form.ataTitle"
					@input="form.ataTitle = $event.target.value.toUpperCase()"
					:disabled="visualizar">
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Maintenance Mode:</label>
			<div class="col-sm-10">
				<select class="form-control form-control-sm"
						v-model="form.maintenanceMode"
						@input="form.maintenanceMode = $event.target.value"
						:disabled="visualizar" required>
					<option value="">Escolha</option>
					<option v-for="(item, index) in maintenanceModes" :key="index" :value="item">{{item}}</option>
				</select>
			</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Interval:</label>
			<div class="col-sm-10">
				<select class="form-control form-control-sm"
						v-model="form.interval"
						@input="form.interval = $event.target.value"
						:disabled="visualizar">
					<option value="null">Escolha</option>
					<option v-for="(item, index) in intervals" :key="index" :value="item">{{item}}</option>
				</select>
			</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Man-hour:</label>
		<div class="col-sm-10">
			<input  type="number" class="form-control form-control-sm"
					v-model="form.homemHora"
					@input="form.homemHora = $event.target.value.toUpperCase()"
					:disabled="visualizar">
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Task Number:</label>
		<div class="col-sm-10">
			<input  type="text" class="form-control form-control-sm"
					v-model="form.taskNumber"
					@input="form.taskNumber = $event.target.value.toUpperCase()"
					:disabled="visualizar">
		</div>
	</div>

	<div class="form-group row" v-if="categoria.substituida">
		<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">Substituida:</label>
		<div class="col-sm-10">
			<select class="form-control form-control-sm"
					v-model="form.descricaoSubstituida"
					@input="form.descricaoSubstituida = $event.target.value.toUpperCase()"
					:disabled="visualizar">
				<option v-for="(item, index) in substituicoes" :key="index" :value="item">{{item}}</option>
			</select>
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">* Task title:</label>
		<div class="col-sm-10">
			<textarea   type="text" class="form-control form-control-sm" rows="1"
						v-model="form.taskTitle"
						@input="form.taskTitle = $event.target.value.toUpperCase()"
						:disabled="visualizar"
						name="task title"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('task title')}">
			</textarea>
			<span  class="invalid-feedback" v-show="errors.has('task title')">{{ errors.first('task title') }}</span>
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Reference Manual:</label>
		<div class="col-sm-10">
			<input  type="text" class="form-control form-control-sm"
					v-model="form.refManual"
					@input="form.refManual = $event.target.value.toUpperCase()"
					:disabled="visualizar">
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Documentation:</label>
		<div class="col-sm-10">
			<textarea   type="text" class="form-control form-control-sm" rows="1"
						v-model="form.documentation"
						@input="form.documentation = $event.target.value.toUpperCase()"
						:disabled="visualizar">
			</textarea>
		</div>
	</div>

	<div class="form-group row">
		<label class="col-sm-2 col-form-label col-form-label-sm">Description:</label>
		<div class="col-sm-10">
			<textarea   type="text" class="form-control form-control-sm" rows="1"
						v-model="form.description"
						@input="form.description = $event.target.value.toUpperCase()"
						:disabled="visualizar">
			</textarea>
		</div>
	</div>
</form>

</template>

<script>
export default {

	props: ['form', 'categoria', 'visualizar'],

	data () {
		return {
			maintenanceModes: ["TBO", "OTL", "OC", "SLL", "CHK"],
			intervals: ["OC", "BFF", "PONCTUAL INTERVAL", "TA", "ALF"],
		}
	},
	computed: {
		substituicoes() {
			console.log("TESTE");
			let arry = [];

			this.categoria.capitulos.map(capitulo => {
				capitulo.inspecoes.map(inspecao => {
				arry.push(inspecao.taskNumber);

				return inspecao;
				});

				return capitulo;
			});

			console.log("ARRAY");

			return arry;
		}
	}

}
</script>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/inspecao/components/cadastro.vue